import Vue from "vue";

// 骨架屏
import SkeletonBox from "~/components/Global/skeleton";
// 加载动画
import SpinnerBox from "~/components/Global/spinner";

import MyPage from "~/components/Global/myPage";

import MyTitle from "~/components/Global/myTitle";

import MyUpload from "~/components/Global/MyUpload";

import MyAreaCascader from "~/components/Global/MyAreaCascader";

import filters from "~/filters";

import htmlToPdf from "~/utils/htmlToPdf"

import MyEditor from "../components/Global/MyEditor";

// filters
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

Vue.use(SkeletonBox);
Vue.use(SpinnerBox);
Vue.use(MyPage);
Vue.use(MyTitle);
Vue.use(MyUpload);
Vue.use(MyAreaCascader);
Vue.use(htmlToPdf)
Vue.use(MyEditor)
